export const FORMAT_DATE_NUMBERS = {
	day: [...Array(31).keys()].map((i) => i + 1),
	month: [...Array(12).keys()].map((i) => i + 1),
	year: [...Array(3).keys()].map((i) => i * 100 + 1700),
};

//DATE
export interface MissingDateOption {
	label: string;
	value: string;
}

export const missingDateOptions: MissingDateOption[] = [
	{
		label: '1700',
		value: '1700',
	},
	{
		label: '01/1700',
		value: '01/1700',
	},
	{
		label: '01/01/1700',
		value: '01/01/1700',
	},
];
